"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _hook = _interopRequireDefault(require("./hook"));
var withStepByStepFormUnlocker = function withStepByStepFormUnlocker(_ref) {
  var mapping = _ref.mapping,
    submitUrlStructure = _ref.submitUrlStructure,
    history = _ref.history;
  return function (BaseComponent) {
    var props = (0, _hook["default"])({
      mapping: mapping,
      submitUrlStructure: submitUrlStructure,
      history: history
    });
    return function (baseProps) {
      return _react["default"].createElement(BaseComponent, (0, _extends2["default"])({}, props, baseProps));
    };
  };
};
var _default = withStepByStepFormUnlocker;
exports["default"] = _default;